import { ReactComponent as CheckBox } from '../assets/icons/check-box.svg'
import { ReactComponent as CheckedBox } from '../assets/icons/checked-box.svg'
import { ReactComponent as DataNull } from '../assets/icons/data-null.svg'
import { ReactComponent as SelectNull } from '../assets/icons/select-null.svg'
// import { ReactComponent as Check } from '../assets/icons/checkmark.svg'
import { useEffect, useState } from 'react'
// import Slide from './Slide.jsx'
import { getSessions, getSessionsBoard } from '../apis/session.ts'
import { dayEnumList } from '../assets/data.js'
import { PostClassRoomBoard } from '../apis/classRoom.ts'
import Slide from './Slide.jsx'

export default function LoadBoard({
  close,
  courseId,
  classroomId,
  currentPage,
  getApi,
  setCurrentPage,
}) {
  /*************** 차시 조회 API **************/
  useEffect(() => {
    getSessionsApi(courseId)
    // eslint-disable-next-line
  }, [courseId])
  const [sessionList, setSessionList] = useState([])
  const getSessionsApi = async (courseId) => {
    const getSessionsResponse = await getSessions({
      courseId: courseId,
      onlyCompleted: true,
      orderBy: 'DESC',
    })

    if (getSessionsResponse.error) {
      console.log(getSessionsResponse)
      return
    } else {
      setSessionList(getSessionsResponse.data)
    }
  }
  const [selectedSession, setSelectedSession] = useState()
  const handleSelectSession = (sessionItem) => {
    if (selectedSession === sessionItem.id) {
      setSelectedSession()
      setSelectedBoard([])
    } else {
      setSelectedSession(sessionItem.id)
      setSelectedBoard([])
    }
  }

  /*************** 보드 생성 - 보드 API **************/
  const postClassRoomBoardApi = async (selectedBoardIds) => {
    const postClassRoomBoardResponse = await PostClassRoomBoard(
      {
        classroomId: classroomId,
      },
      {
        currentPageNumber: currentPage,
        boardIds: selectedBoardIds,
      },
    )

    if (postClassRoomBoardResponse.error) {
      console.log(postClassRoomBoardResponse.error)
      return
    } else {
      console.log(postClassRoomBoardResponse.result)
      await getApi()
      setCurrentPage(postClassRoomBoardResponse.data)
    }
  }

  /*************** 특정 차시 하위 보드 가져오기 API **************/
  useEffect(() => {
    if (selectedSession) {
      getSessionBoardApi(selectedSession)
    }
  }, [selectedSession])

  const [sessionBoardList, setSessionBoardList] = useState([])
  const getSessionBoardApi = async (sessionId) => {
    const getSessionBoardResponse = await getSessionsBoard({ sessionId: sessionId })

    if (getSessionBoardResponse.error) {
      console.log(getSessionBoardResponse.error)
      return
    } else {
      setSessionBoardList(getSessionBoardResponse.data)
    }
  }

  const [selectedBoard, setSelectedBoard] = useState([])

  const handleSelectBoard = (id) => {
    if (!selectedBoard?.includes(id)) {
      setSelectedBoard((prev) => [...prev, id])
    } else {
      const unSelectedBoard = selectedBoard.filter((item) => item !== id)
      setSelectedBoard(unSelectedBoard)
    }
  }
  const handleAllCheck = (list) => {
    if (selectedBoard.length !== sessionBoardList.length) {
      const checked = []
      list.forEach((item) => checked.push(item.id))
      setSelectedBoard(checked)
    } else {
      setSelectedBoard([])
    }
  }
  return (
    <div className='fixed left-0 top-0 z-[999] flex h-full w-full items-center justify-center overflow-auto bg-dimmer-default'>
      <div className='modal_xs board:modal_md tab:h-[400px] board:h-[526px] board:min-w-[1028px] board:pb-20 board:max-w-[1272px] board:gap-20 tab:min-w-[770px] tab:modal_sm tab:pb-16 tab:gap-16 h-[342px] max-w-[592px] gap-12'>
        <p className='tab:text-h1-semibold text-caption-semibold text-label-default'>
          보드 불러오기
        </p>
        {sessionList?.length === 0 ? (
          <div className='board:gap-16 board:rounded-12 flex h-full w-full flex-col items-center justify-center gap-8 rounded-6 bg-fill-normal'>
            <DataNull />
            <div className='board:gap-4 text-caption3-medium tab:text-h2-medium flex flex-col gap-2 text-center text-label-placeholder'>
              <p>진행된 수업 보드가 없습니다.</p>
              <p>보드 불러오기는 해당 수업의 완료된 차시 보드만 가능합니다.</p>
            </div>
          </div>
        ) : (
          <div className='board:gap-12 flex h-full gap-8 overflow-hidden'>
            <div className='h-full grow'>
              {/* dataList */}
              <div className='tab:gap-16 tab:px-16 tab:py-8 text-caption2-regular tab:text-body3-regular flex w-full items-center gap-8 border-y-[1px] border-solid border-border-default bg-fill-alternative px-12 py-4 text-label-info'>
                <p className='tab:min-w-50 board:min-w-60 min-w-40'>주차</p>
                <p className='tab:min-w-50 board:min-w-60 min-w-40'>차시</p>
                <p className='tab:min-w-[134px] board:min-w-[246px] min-w-[98px]'>설명</p>
                <p className='tab:min-w-[140px] board:min-w-[150px] min-w-80'>일시</p>
              </div>
              <div className='scroll-bar-xs h-full w-full overflow-y-auto'>
                {sessionList?.map((weekItem, documentIndex) =>
                  weekItem.sessions.map((sessionItem, index) => (
                    <div
                      key={index}
                      onClick={() => handleSelectSession(sessionItem)}
                      className={`${selectedSession === sessionItem.id ? 'bg-background-secondary' : 'bg-background-default'} text-caption2-regular tab:text-body2-regular board:text-body2-medium board:p-16 tab:gap-16 tab:px-16 tab:py-12 flex w-full items-center justify-between gap-8 border-b-[1px] border-solid border-border-default px-12 py-10 text-label-sub active:bg-background-secondary`}
                    >
                      <p className='tab:min-w-50 board:min-w-60 min-w-40'>{`${sessionItem.week}주차`}</p>
                      <p className='tab:min-w-50 board:min-w-60 min-w-40'>{`${sessionItem.order}차시`}</p>
                      <p className='tab:min-w-[134px] board:min-w-[246px] w-[98px] overflow-hidden text-ellipsis whitespace-nowrap'>
                        {sessionItem.description}
                      </p>
                      <p className='tab:min-w-[140px] board:min-w-[150px] min-w-100'>{`${sessionItem.startDate} ${dayEnumList[sessionItem.dayOfWeek]} ${sessionItem.period}교시`}</p>
                    </div>
                  )),
                )}
              </div>
            </div>
            <div className='board:w-[340px] board:rounded-12 tab:w-[236px] flex w-[210px] items-center justify-center rounded-6 bg-fill-normal'>
              {selectedSession ? (
                sessionBoardList.length === 0 ? (
                  <div className='flex h-full w-full flex-col items-center justify-center gap-8'>
                    <DataNull className='h-40 w-40' />
                    <p className='text-caption2-medium tab:text-body2-long-medium text-center text-label-placeholder'>
                      해당 보드에 페이지가 없습니다
                    </p>
                  </div>
                ) : (
                  <div className='board:px-8 flex h-full w-full flex-col items-start justify-start px-[5px]'>
                    <div
                      onClick={() => handleAllCheck(sessionBoardList)}
                      className='board:py-[13px] flex cursor-pointer items-center gap-4 py-[7px]'
                    >
                      {selectedBoard.length > 0 &&
                      selectedBoard.length === sessionBoardList?.length ? (
                        <CheckedBox className='board:w-20 board:h-20 h-[14px] w-[14px]' />
                      ) : (
                        <CheckBox className='board:w-20 board:h-20 h-[14px] w-[14px]' />
                      )}
                      <p
                        className={`text-caption3-medium tab:text-body3-medium board:text-body2-medium ${selectedBoard.length > 0 && selectedBoard.length === sessionBoardList.length ? 'text-border-active' : 'text-label-info'}`}
                      >
                        {selectedBoard.length > 0 &&
                        selectedBoard.length === sessionBoardList.length
                          ? '전체 선택 해제'
                          : '전체 선택'}
                      </p>
                    </div>
                    <div className='tab:gap-8 scroll-bar-xs tab:grid-cols-1 board:grid-cols-2 grid w-full grid-cols-2 gap-4 overflow-y-scroll pb-[7px]'>
                      {sessionBoardList?.map((boardItem, index) => (
                        <div
                          key={index}
                          onClick={() => handleSelectBoard(boardItem.id)}
                          className='board:h-[85px] tab:h-[114px] h-[53px] w-full'
                        >
                          <Slide
                            url={boardItem.backgroundImageUrl}
                            id={boardItem.id}
                            selectedSlide={selectedBoard}
                            pageNum={index + 1}
                            selectedMode={Boolean(selectedSession)}
                            isSmall={true}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )
              ) : (
                <div className='flex flex-col items-center gap-8'>
                  <SelectNull className='h-40 w-40' />
                  <p className='text-caption2-medium tab:text-body2-long-medium text-center text-label-placeholder'>
                    리스트에서 불러올
                    <br />
                    보드를 선택하세요
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
        <div className='flex w-full justify-end'>
          <div
            className={`${sessionList?.length > 0 ? 'tab:w-[256px] board:w-[320px] w-[192px]' : 'tab:min-w-[124px] board:min-w-[152px] min-w-100'} board:gap-16 flex justify-end gap-8`}
          >
            <button
              onClick={close}
              className='button_outlined_secondary text-caption2-medium tab:button_outlined_secondary_lg tab:py-10 tab:text-label-sub tab:text-body2-semibold tab:min-w-[124px] w-full rounded-6 py-8 text-label-sub'
            >
              취소
            </button>
            {sessionList?.length > 0 && (
              <button
                disabled={selectedBoard.length === 0}
                onClick={async () => {
                  await postClassRoomBoardApi(selectedBoard)
                  //   await getApi()
                  close()
                }}
                className={`text-caption2-medium tab:py-10 tab:text-body2-semibold tab:px-20 tab:min-w-[124px] w-full text-nowrap rounded-6 py-8 ${selectedBoard.length > 0 ? 'button_solid_primary tab:button_solid_primary_lg' : 'button_solid_primary_disabled tab:button_solid_primary_disabled_lg'}`}
              >
                {`${selectedBoard.length > 0 ? `선택 보드 추가(${selectedBoard.length})` : '선택 보드 추가'}`}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
